/**
 * @file debugRoutine.js
 *
 * Conditionally suppresses console output on production by replacing
 * console.log, console.debug, console.warn, and console.info with no-ops.
 * console.error is intentionally left intact so Faro can intercept it.
 *
 * Debug mode is enabled on:
 *   - Any hostname containing .ddev.site   (local development)
 *   - Any hostname containing .542.        (542 staging environments)
 *   - Any hostname containing ms.g         (ms.gold.org)
 *   - Any hostname containing uat.g        (uat.gold.org)
 *   - Any URL containing the query string ?debug (manual override)
 *
 * Debug mode is force-disabled on:
 *   - Any hostname containing pentest      (penetration testing environments)
 *
 * Load order: weight -201, between the Faro vendor bundle (-202) and
 * faro-telemetry.js (-200). Must remain at a lower weight than faro-telemetry.js
 * so that Faro wraps the already-suppressed console methods — ensuring console
 * errors are still captured by Faro even when output is suppressed.
 *
 * @see js/faro-telemetry.js
 */

/** @type {boolean} Whether verbose console output is enabled. */
var _debug = false;

if (
  location.search.search('ebug') > 1 ||
  location.hostname.search('.542.') > 1 ||
  location.hostname.search('.ddev.site') > 1 ||
  location.hostname.search('ms.g') > 1 ||
  location.hostname.search('uat.g') > 1
) {
  _debug = true;
  console.warn('Console messages are on.');
}

// Pentest environments suppress output regardless of hostname patterns above.
if (location.hostname.search('pentest') > 1) {
  _debug = false;
}

if (!_debug) {
  if (!window.console) window.console = {};

  /**
   * Methods to suppress on production. console.error is excluded so that
   * Faro's error instrumentation and the wgcMonitoring shim continue to work.
   *
   * @type {string[]}
   */
  var methods = ['log', 'debug', 'warn', 'info'];
  for (var i = 0; i < methods.length; i++) {
    console[methods[i]] = function () {};
  }
}
